import React from 'react'
import { Route, Redirect, Switch } from 'react-router'
import { layoutConfigs } from 'shared/layoutConfigs'
import { GlobalOnlyRoute, requireAuthWrapper, requirePremiumWrapper } from 'components/util/Routers'

import NotFoundPage from 'components/layout/NotFoundPage'

// landing
import ChinaLanding from 'components/landing/china/Landing'
import GlobalLanding from 'components/landing/global/Landing'

// home
import ActivityFeed from 'components/home/ActivityFeed'
import Dashboard from 'components/home/Dashboard'

// premium
import CheckoutPage from 'components/premium/CheckoutPage'
import ReceiptPage from 'components/premium/ReceiptPage'
import CouponPage from 'components/premium/CouponPage'
import SubscriptionSettings from 'components/premium/SubscriptionSettings'

// routes
import RoutePrintPage from 'components/routes/print/RoutePrintPage'
import RouteSearchPage from 'components/routes/search/RouteSearchPage'
import MyRoutesPage from 'components/routes/myRoutes/MyRoutesPage'
import MyBookmarksPage from 'components/routes/myRoutes/MyBookmarksPage'
import MyCoursesPage from 'components/routes/myRoutes/MyCoursesPage'
import RouteLandingPage from 'components/routes/landing/RouteLandingPage'

// workouts
import LifetimeStatsPage from 'components/workouts/dashboard/lifetime/LifetimeStatsPage'
import LogWorkoutPage from 'components/workouts/create/LogWorkoutPage'
import CopyWorkoutPage from 'components/workouts/copy/CopyWorkoutPage'
import EditWorkoutPage from 'components/workouts/edit/EditWorkoutPage'

// friends
import MyFriends from 'components/friends/MyFriends'
import InviteFriends from 'components/friends/InviteFriends'
import FindFriends from 'components/friends/FindFriends'

// goals
import PersonalGoalsPage from 'components/goals/view/PersonalGoalsPage'
import CreateGoalPage from 'components/goals/create/CreateGoalPage'

// app
import AppPage from 'components/app-page/AppPage'

// auth
import LoginPage from 'components/auth/login/LoginPage'
import SignupPage from 'components/auth/signup/SignupPage'
import ForgotPasswordPage from 'components/auth/forgotPassword/ForgotPasswordPage'

// privacy center
import ConsentsPage from 'components/privacy_center/consents'
import ManagePage from 'components/privacy_center/manage/ManagePage'
import ManageMobile from 'components/privacy_center/manage/ManageMobile'
import HelpPage from 'components/privacy_center/help/HelpPage'
import HelpPageMobile from 'components/privacy_center/help/HelpMobile'
import AgeGatePage from 'components/privacy_center/age-gate/AgeGatePage'
import AgeGateMobile from 'components/privacy_center/age-gate/AgeGateMobile'
import DeclinePage from 'components/privacy_center/decline/DeclinePage'
import DeclineMobile from 'components/privacy_center/decline/DeclineMobile'
import ConsentsEditPage from 'components/privacy_center/consents-edit/ConsentsEditPage'
import ConsentsEditMobile from 'components/privacy_center/consents-edit/ConsentsEditMobile'

// layouts
import DefaultLayout from 'components/layout/DefaultLayout'
import PrivacyLayout from 'components/layout/PrivacyCenterLayout'
import WideLayout from 'components/layout/WideLayout'
import AuthLayout from 'components/layout/AuthLayout'
import PremiumLayout from 'components/layout/PremiumLayout'
import UACFLayout from 'components/layout/UACFLayout'

// migrate
import Migrate from 'components/migration/Migrate'
import MigrateConfirmed from 'components/migration/MigrateConfirmed'

// Samsung Gear Connect
import SamsungGearConnect from 'components/samsung_gear_connect/samsung_gear_connect'

// deletion
import DeletionPage from 'components/deletion/DeletionPage'
import DeletionMobile from 'components/deletion/DeletionMobile'

export const getRoutes = (store) => {
  const { bootup } = store.getState()
  const { isChina } = bootup.appConfig

  const layoutOverwrites = layoutConfigs(isChina)

  return (
    <Switch>
      <Route exact path='/'>
        <WideLayout {...layoutOverwrites} hideAds={true}>
          {isChina ?
            <ChinaLanding />
          :
            <GlobalLanding />
          }
        </WideLayout>
      </Route>

      <GlobalOnlyRoute path='/app' component={() => (
        <WideLayout {...layoutOverwrites} hideAds={true}>
          <Route exact component={AppPage} />
        </WideLayout>
      )} />

      {/* my_home */}
      <Route exact path='/my_home'>
        <DefaultLayout {...layoutOverwrites}>
          <ActivityFeed />
        </DefaultLayout>
      </Route>

      <Route exact path='/my_home/dashboard'>
        <DefaultLayout {...layoutOverwrites}>
          <Dashboard />
        </DefaultLayout>
      </Route>

      {/* auth */}
      <Route exact path='/auth/login'>
        <AuthLayout {...layoutOverwrites} hideAds={true}>
          <LoginPage />
        </AuthLayout>
      </Route>

      <Route exact path='/auth/login/uacf'>
        <UACFLayout {...layoutOverwrites} hideAds={true}>
          <LoginPage />
        </UACFLayout>
      </Route>

      <Route exact path='/auth/signup'>
        <AuthLayout {...layoutOverwrites} hideAds={true}>
          <SignupPage />
        </AuthLayout>
      </Route>

      <Route exact path='/auth/signup/uacf'>
        <UACFLayout {...layoutOverwrites} hideAds={true}>
          <SignupPage />
        </UACFLayout>
      </Route>

      <Route exact path='/auth/forgot_password/'>
        <AuthLayout {...layoutOverwrites}>
          <ForgotPasswordPage />
        </AuthLayout>
      </Route>

      <Route exact path='/auth/forgot_password/uacf'>
        <UACFLayout {...layoutOverwrites}>
          <ForgotPasswordPage />
        </UACFLayout>
      </Route>

      {/* privacy_center */}
      <Route exact path='/privacy_center/manage'>
        <DefaultLayout {...layoutOverwrites}>
          <ManagePage />
        </DefaultLayout>
      </Route>
      <Route exact path='/mobile/privacy_center/manage'>
        <ManageMobile />
      </Route>

      <Route exact path='/privacy_center/consents/decline'>
        <DefaultLayout {...layoutOverwrites}>
          <DeclinePage />
        </DefaultLayout>
      </Route>
      <Route exact path='/mobile/privacy_center/consents/decline'>
        <DeclineMobile />
      </Route>

      <Route exact path='/privacy_center/consents/edit'>
        <DefaultLayout {...layoutOverwrites}>
          <ConsentsEditPage />
        </DefaultLayout>
      </Route>
      <Route exact path='/mobile/privacy_center/consents/edit'>
        <ConsentsEditMobile />
      </Route>

      <Route exact path='/privacy_center/consents'>
        <PrivacyLayout {...layoutOverwrites}>
          <ConsentsPage />
        </PrivacyLayout>
      </Route>

      <Route exact path='/privacy_center/help'>
        <PrivacyLayout {...layoutOverwrites}>
          <HelpPage />
        </PrivacyLayout>
      </Route>
      <Route exact path='/mobile/privacy_center/help'>
        <HelpPageMobile />
      </Route>

      <Route exact path='/privacy_center/ineligible'>
        <PrivacyLayout {...layoutOverwrites}>
          <AgeGatePage />
        </PrivacyLayout>
      </Route>
      <Route exact path='/mobile/privacy_center/ineligible'>
        <AgeGateMobile />
      </Route>

      <Route exact path='/account/delete'>
        <PrivacyLayout {...layoutOverwrites}>
          <DeletionPage />
        </PrivacyLayout>
      </Route>

      <Route exact path='/account/delete'>
        <PrivacyLayout {...layoutOverwrites}>
          <DeletionPage />
        </PrivacyLayout>
      </Route>

      <Route exact path='/mobile/account/delete'>
        <DeletionMobile />
      </Route>

      {/* premium */}
      <GlobalOnlyRoute exact path='/premium/membership' component={requireAuthWrapper(() => (
        <PremiumLayout {...layoutOverwrites}>
          <SubscriptionSettings />
        </PremiumLayout>
      ))} />

      <Redirect exact path='/premium' to='/premium/membership' />

      <GlobalOnlyRoute exact path='/premium/checkout' component={requireAuthWrapper(() => (
        <PremiumLayout {...layoutOverwrites}>
          <CheckoutPage />
        </PremiumLayout>
      ))} />

      <GlobalOnlyRoute exact path='/premium/coupon' component={requireAuthWrapper(() => (
        <PremiumLayout {...layoutOverwrites}>
          <CouponPage />
        </PremiumLayout>
      ))} />

      <GlobalOnlyRoute exact path='/premium/receipt/:id' component={requireAuthWrapper(() => (
        <PremiumLayout {...layoutOverwrites}>
          <ReceiptPage />
        </PremiumLayout>
      ))} />

      {/* workouts */}
      <Route exact path='/workouts/dashboard/lifetime' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Workouts'] }]} {...layoutOverwrites}>
          <LifetimeStatsPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/workout/create/' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Workouts'] }]} {...layoutOverwrites}>
          <LogWorkoutPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/workout/copy/:workoutId' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Workouts'] }]} {...layoutOverwrites}>
          <CopyWorkoutPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/workout/edit/:workoutId' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Workouts'] }]} {...layoutOverwrites}>
          <EditWorkoutPage />
        </DefaultLayout>
      ))} />

      {/* people */}
      <Route exact path='/people/friends' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Groups'] }]} {...layoutOverwrites}>
          <MyFriends />
        </DefaultLayout>
      ))} />

      <Route exact path='/people/friends/find' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Groups'] }]} {...layoutOverwrites}>
          <FindFriends />
        </DefaultLayout>
      ))} />

      <Route exact path='/people/friends/invite' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Groups'] }]} {...layoutOverwrites}>
          <InviteFriends />
        </DefaultLayout>
      ))} />

      {/* routes */}
      <Route exact path='/routes/print/:routeId' component={requirePremiumWrapper(() => (
        <RoutePrintPage />
      ))} />

      <Route exact path='/routes/search' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Maps_Routes'] }]} {...layoutOverwrites}>
          <RouteSearchPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/routes/my_routes' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Maps_Routes'] }]} {...layoutOverwrites}>
          <MyRoutesPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/routes/my_routes/bookmarks' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Maps_Routes'] }]} {...layoutOverwrites}>
          <MyBookmarksPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/routes/my_routes/courses' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Maps_Routes'] }]} {...layoutOverwrites}>
          <MyCoursesPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/routes'>
        <WideLayout routes={[{ adUnitPaths: ['Maps_Routes'] }]} {...layoutOverwrites}>
          <RouteLandingPage />
        </WideLayout>
      </Route>

      {/* goals */}
      <Route exact path='/profile/:userId/goals' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Goals'] }]} {...layoutOverwrites}>
          <PersonalGoalsPage />
        </DefaultLayout>
      ))} />

      <Route exact path='/profile/:userId/goals/create' component={requireAuthWrapper(() => (
        <DefaultLayout routes={[{ adUnitPaths: ['Goals'] }]} {...layoutOverwrites}>
          <CreateGoalPage />
        </DefaultLayout>
      ))} />

      {/* misc. webviews */}
      <Route path='/mobile/china/migrate/user/confirm/:token' component={MigrateConfirmed} />
      <Route path='/mobile/china/migrate/user/:chinaUserId/:username' component={Migrate} />
      <Route path='/mobile/samsung_gear_connect/:stashedid' component={SamsungGearConnect} />

      <Route>
        <DefaultLayout {...layoutOverwrites}>
          <NotFoundPage />
        </DefaultLayout>
      </Route>

    </Switch>
  )
}

